import React, { Component } from "react";
import { Card, Select } from "antd";
import { TopKeywordsReportContainer } from "../../containers/TopKeywords";
import { ChangeSeoDb } from "../../containers";
import TopKeywordsOverview from "./Overview";
import ReportCardTitle from "../shared/ReportCardTitle/ReportCardTitle";
const { Option } = Select;

class TopKeywordsLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderBy: "tr",
      orderDir: "desc"
    };
  }

  handleChange = selectedValue => {
    const [orderBy, orderDir] = selectedValue.split("_");
    this.setState({ orderBy, orderDir });
  };

  render() {
    return (
      <React.Fragment>
        <TopKeywordsOverview overview={this.props.overview} isLoading={this.props.isLoading} />

        <Card
          className="keywords-data-overview"
          title={<ReportCardTitle title="Top keywords" domain={this.props.domain} />}
          extra={
            <div className="keywords-options card-actions">
              <div className="sort-by">
                <Select
                  defaultValue={`${this.state.orderBy}_${this.state.orderDir}`}
                  onChange={this.handleChange}
                  value={`${this.state.orderBy}_${this.state.orderDir}`}>
                  <Option value={"tr_desc"}>High traffic</Option>
                  <Option value={"pos_asc"}>High position</Option>
                  <Option value={"tr_asc"}>Low traffic</Option>
                  <Option value={"pos_desc"}>Low position</Option>
                </Select>
              </div>
              <ChangeSeoDb
                domain={this.props.domain}
                seoDb={this.props.seoDb}
                resetSortBy={this.handleChange}
                postAction="reload_top_keywords"
              />
            </div>
          }>
          <TopKeywordsReportContainer
            domain={this.props.domain}
            seoDb={this.props.seoDb}
            showSuggestions={this.props.showSuggestions}
            {...this.state}
          />
        </Card>
      </React.Fragment>
    );
  }
}

export default TopKeywordsLayout;
